(function () {
  'use strict';
  if (window.hxaZelloaEditorialLoaded) return;
  window.hxaZelloaEditorialLoaded = true;
  var instances = new WeakMap();
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initialize(root) {
    if (!root || instances.has(root)) return;
    var cleanup = [];
    instances.set(root, cleanup);

    // Never hide the content: an optional short reveal begins only in view.
    if ('IntersectionObserver' in window && !reducedMotion.matches) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          if (reducedMotion.matches || typeof entry.target.animate !== 'function') return;
          entry.target.animate([
            { opacity: 0.5, transform: 'translateY(12px)' },
            { opacity: 1, transform: 'translateY(0)' }
          ], { duration: 440, easing: 'cubic-bezier(.22,.7,.2,1)' });
        });
      }, { threshold: 0.06 });
      root.querySelectorAll('[data-hxa-z-reveal]').forEach(function (node) { observer.observe(node); });
      cleanup.push(function () { observer.disconnect(); });
    }

    root.querySelectorAll('[data-hxa-z-stones]').forEach(function (stage) {
      var track = stage.querySelector('[data-hxa-z-track]');
      var navigation = stage.querySelector('[data-hxa-z-navigation]');
      var previous = stage.querySelector('[data-hxa-z-previous]');
      var next = stage.querySelector('[data-hxa-z-next]');
      var position = stage.querySelector('[data-hxa-z-position]');
      if (!track || !navigation || !previous || !next || !position) return;
      var cards = Array.from(track.children);
      var frame = 0;
      function update() {
        frame = 0;
        var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        navigation.hidden = maxScroll <= 4;
        previous.disabled = track.scrollLeft <= 4;
        next.disabled = track.scrollLeft >= maxScroll - 4;
        var closest = 0;
        var distance = Infinity;
        cards.forEach(function (card, index) {
          var delta = Math.abs(card.offsetLeft - cards[0].offsetLeft - track.scrollLeft);
          if (delta < distance) { distance = delta; closest = index; }
        });
        if (maxScroll > 4 && track.scrollLeft >= maxScroll - 4) closest = cards.length - 1;
        position.textContent = (closest + 1) + ' / ' + cards.length;
      }
      function scheduleUpdate() { if (!frame) frame = window.requestAnimationFrame(update); }
      function scroll(direction) {
        if (!cards.length) return;
        var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
        track.scrollBy({ left: direction * (cards[0].getBoundingClientRect().width + gap), behavior: reducedMotion.matches ? 'auto' : 'smooth' });
      }
      function onPrevious() { scroll(-1); }
      function onNext() { scroll(1); }
      function onKey(event) {
        if (event.target !== track || navigation.hidden) return;
        if (event.key === 'ArrowRight') { event.preventDefault(); scroll(1); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); scroll(-1); }
      }
      previous.addEventListener('click', onPrevious);
      next.addEventListener('click', onNext);
      track.addEventListener('keydown', onKey);
      track.addEventListener('scroll', scheduleUpdate, { passive: true });
      window.addEventListener('resize', scheduleUpdate, { passive: true });
      var resizeObserver = 'ResizeObserver' in window ? new ResizeObserver(scheduleUpdate) : null;
      if (resizeObserver) resizeObserver.observe(track);
      update();
      cleanup.push(function () {
        previous.removeEventListener('click', onPrevious);
        next.removeEventListener('click', onNext);
        track.removeEventListener('keydown', onKey);
        track.removeEventListener('scroll', scheduleUpdate);
        window.removeEventListener('resize', scheduleUpdate);
        if (resizeObserver) resizeObserver.disconnect();
        if (frame) window.cancelAnimationFrame(frame);
      });
    });
  }
  function initializeWithin(scope) {
    if (scope.matches && scope.matches('[data-hxa-z]')) initialize(scope);
    scope.querySelectorAll('[data-hxa-z]').forEach(initialize);
  }
  function cleanRoot(root) {
    var callbacks = instances.get(root);
    if (callbacks) callbacks.forEach(function (callback) { callback(); });
    instances.delete(root);
  }
  initializeWithin(document);
  document.addEventListener('shopify:section:load', function (event) { initializeWithin(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    if (event.target.matches('[data-hxa-z]')) cleanRoot(event.target);
    event.target.querySelectorAll('[data-hxa-z]').forEach(cleanRoot);
  });
})();
